import { IFeedback } from "../../../../../model/feedback";

interface IFeedbackContent {
  title: string;
  feedbacks: Array<IFeedback>;
}

export const feedbackContent: IFeedbackContent = {
  title: "Veja o que nossos %associados% falam sobre nós:",
  feedbacks: [
    {
      title: "Marcos Vinícius Almeida",
      subtitle: "Servidor Público",
      comment:
        "Depois que comecei a usar o cartão de convênio, passei a prestar mais atenção nos estabelecimentos parceiros. É uma facilidade que acaba sendo útil em várias situações.",
      rate: 5,
    },
    {
      title: "Juliana Ferreira Martins",
      subtitle: "Servidora Pública",
      comment:
        "Já tive algumas dúvidas relacionadas ao trabalho e sempre procurei o SISEP antes de tomar qualquer decisão. Ter esse apoio faz muita diferença para nós, servidores.",
      rate: 5,
    },
    {
      title: "Carlos Eduardo Rodrigues",
      subtitle: "Servidor Público",
      comment:
        "Uma coisa que gosto no SISEP é que não fica só na questão sindical. Os convênios e o cartão também ajudam bastante no dia a dia.",
      rate: 5,
    },
    {
      title: "Patrícia Cristina Oliveira",
      subtitle: "Servidora Pública",
      comment:
        "Eu não conhecia todos os convênios disponíveis até começar a acompanhar as novidades do SISEP. Hoje sempre dou uma olhada antes de fazer alguma compra ou procurar um serviço.",
      rate: 5,
    },
    {
      title: "André Luiz Barbosa",
      subtitle: "Servidor Público",
      comment:
        "Quando precisei de orientação, fui atendido de forma muito tranquila e consegui entender melhor minha situação. É bom saber que podemos contar com o SISEP quando surge alguma dificuldade.",
      rate: 5,
    },
    {
      title: "Renata Alves da Silva",
      subtitle: "Servidora Pública",
      comment:
        "O cartão de convênio é uma praticidade que eu realmente aproveito. Principalmente quando encontro um estabelecimento que já conheço e descubro que também é parceiro do SISEP.",
      rate: 5,
    },
    {
      title: "Rafael Moreira Santos",
      subtitle: "Servidor Público",
      comment:
        "Ser associado é saber que você tem alguém para procurar quando aparece uma dúvida ou um problema. Já precisei desse suporte e fiquei satisfeito com o atendimento.",
      rate: 5,
    },
    {
      title: "Camila Fernanda Costa",
      subtitle: "Servidora Pública",
      comment:
        "Comecei a conhecer melhor o SISEP justamente pelos convênios. Depois fui descobrindo os outros serviços oferecidos aos associados e percebi que havia muito mais do que eu imaginava.",
      rate: 5,
    },
    {
      title: "Leonardo Pereira Souza",
      subtitle: "Servidor Público",
      comment:
        "Já utilizei o cartão de convênio algumas vezes e achei bem simples. Gosto dessa ideia de ter parceiros que oferecem condições diferenciadas para quem é associado.",
      rate: 5,
    },
    {
      title: "Aline Carvalho Mendes",
      subtitle: "Servidora Pública",
      comment:
        "Uma das vantagens de ser associado é poder contar com diferentes tipos de suporte. Já precisei de orientação jurídica e também já aproveitei os convênios. Para mim, isso agrega bastante.",
      rate: 5,
    },
  ],
};
